import { render, staticRenderFns } from "./liveEditPage.vue?vue&type=template&id=58f7c4a1&"
import script from "./liveEditPage.vue?vue&type=script&lang=ts&"
export * from "./liveEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports